import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import Vue from 'vue';
import CancelLegalProtectionRequestModel from '../../generated/types/model/resource/CancelLegalProtectionRequestModel';
import utils from '../utils';
import RequestSummaryResourceViewModel from './RequestSummaryResourceViewModel';

export default class CancelLegalProtectionRequestViewModel extends CancelLegalProtectionRequestModel {
  protected transformToDTO() {
    this.dto.summary = this.summary.getDTO();
  }
  protected transformFromDTO() {}

  schema: IJSONSchema = {
    ...queryBuilder.properties({
      reasonForTermination: { required: true },
      cancellationDate: { required: true },
    }),
  };

  get summary(): RequestSummaryResourceViewModel {
    return new RequestSummaryResourceViewModel().fromDTO({
      sections: [
        {
          title: Vue.$t('page.memberData.title.cancelCoopLegalProtection'),
          items: [
            {
              ...utils.insertIf(!!this.reasonForTermination, {
                label: Vue.$t('page.memberData.label.reasonForTermination'),
                displayValue: this.reasonForTermination,
              }),
            },
            {
              ...utils.insertIf(!!this.cancellationDate, {
                label: Vue.$t('page.memberData.label.cancellationDate'),
                displayValue: Vue.$format.localDate(this.cancellationDate!),
              }),
            },
            {
              ...utils.insertIf(!!this.comment, {
                label: Vue.$t('page.memberData.label.comment'),
                displayValue: this.comment,
              }),
            },
          ],
        },

      ],
    });
  }
}
